// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1527":"c7649cd5","1677":"c7649cd5","4339":"ccf8758b"}[chunkId] + ".chunk.css";
};